import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { authStore } from '@/stores/authStore';
import UserMenu from './UserMenu';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from './LanguageSwitcher';

const Navbar = observer(() => {
  const user = authStore.user;
  const currentOrg = authStore.currentOrganization;
  const { t } = useTranslation();

  if (!user) return null;
  
  // Function to get the absolute URL for logo if it's a relative path
  const getLogoUrl = (logoPath: string | undefined) => {
    if (!logoPath) return undefined;
    if (logoPath.startsWith('http')) return logoPath;
    return `${import.meta.env.VITE_API_URL}${logoPath}`;
  };

  return (
    <nav className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link to="/" className="flex-shrink-0 flex items-center">
              {currentOrg?.logo ? (
                <img 
                  src={getLogoUrl(currentOrg.logo)} 
                  alt={currentOrg.name} 
                  className="h-8 w-auto object-contain"
                />
              ) : (
                <span className="text-xl font-bold">{currentOrg?.name || t('common.yourApp', 'Your App')}</span>
              )}
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-700">{t('common.welcome', 'Welcome')}, {user.name}!</span>
            <LanguageSwitcher />
            <UserMenu />
          </div>
        </div>
      </div>
    </nav>
  );
});

export default Navbar; 